'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { getBackgroundColor, getHeaderTextColor, getHeaderBackgroundColor } from 'conversations-message-history/primary-message/operators/themeGetters';
import { OBSIDIAN, OLAF, MARIGOLD_LIGHT } from 'HubStyleTokens/colors';
import ThemeContext from 'conversations-message-history/primary-message/provider/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageHeaderContentWrapper = styled.div.attrs({
  'data-test-id': 'primary-message-header-content'
}).withConfig({
  displayName: "PrimaryMessageHeaderContent__PrimaryMessageHeaderContentWrapper",
  componentId: "x1233y-0"
})(["min-width:0;margin-right:auto;background-color:", ";padding:'0';width:100%;color:", ";display:flex;flex-direction:row;"], OLAF, OBSIDIAN);
export default class PrimaryMessageHeaderContent extends PureComponent {
  render() {
    const {
      children,
      className,
      isForwarded
    } = this.props;
    return /*#__PURE__*/_jsx(PrimaryMessageHeaderContentWrapper, {
      backgroundColor: getBackgroundColor(this.context),
      headerBackgroundColor: isForwarded ? MARIGOLD_LIGHT : getHeaderBackgroundColor(this.context),
      headerTextColor: isForwarded ? OBSIDIAN : getHeaderTextColor(this.context),
      className: className,
      children: children
    });
  }
}
PrimaryMessageHeaderContent.contextType = ThemeContext;
PrimaryMessageHeaderContent.displayName = 'PrimaryMessageHeaderContent';
PrimaryMessageHeaderContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isForwarded: PropTypes.bool
};